import { render, staticRenderFns } from "./DonorApneaTestDetailsPrint.vue?vue&type=template&id=8c7204e4"
import script from "./DonorApneaTestDetailsPrint.vue?vue&type=script&lang=js"
export * from "./DonorApneaTestDetailsPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports